import {
	SELECT_FLIGHT,
	UNSELECT_FLIGHT,
	SELECT_ROUNDTRIP_FLIGHTS,
	UPDATE_SELECTED_FLIGHT
} from "../shared/constants";
import R from "ramda";
import { decorateFlight } from "../shared/utils";

export const initialSelectedFlightsState = {
	inbound: [],
	outbound: []
};

export const selectedFlights = (state = initialSelectedFlightsState, action) => {
	switch (action.type) {
		case SELECT_FLIGHT:
			return { ...state, [action.flight.direction]: [action.flight] };

		case SELECT_ROUNDTRIP_FLIGHTS:
			return {
				...state,
				inbound: action.flights.filter(flight => flight.direction === "inbound"),
				outbound: action.flights.filter(flight => flight.direction === "outbound")
			};

		case UNSELECT_FLIGHT:
			return { ...state, [action.flight.direction]: [] };

		case UPDATE_SELECTED_FLIGHT:
			action.flights.forEach(flight => {
				let flightIndex = R.findIndex(R.propEq("id", flight.id))(state[flight.direction]);

				if (state[flight.direction][flightIndex].updated != true) {
					state[flight.direction][flightIndex] = decorateFlight(flight);
					state[flight.direction][flightIndex].updated = true;
				}
			});

			return { ...state };

		default:
			return state;
	}
};
